import { Resource } from '../../../http/resource/resource.model';

export class DomainPortal extends Resource {
  // id is inherited from Resource
  // client_id is inherited from Resource
  // tslint:disable-next-line: variable-name
  option_domain: number;
  // tslint:disable-next-line: variable-name
  system_domain: string;
  // tslint:disable-next-line: variable-name
  client_domain: string;
  scopeChangeSettings: string;
  last_change: Date;
  changed_by: string;
  front_url: string;
  CNAME: string;
}
